import coachImage from '../../assets/image/image.png';

function AboutSection() {
  const stats = [
    { value: "25+", label: "Years Experience", icon: "📅" },
    { value: "₹43Cr+", label: "Recovered", icon: "💰" },
    { value: "104+", label: "Seminars", icon: "🎤" },
    { value: "18,000+", label: "Business Owners", icon: "👥" },
    { value: "602", label: "Active Students", icon: "🎓" }
  ];

  return (
    <section className="relative py-20 md:py-28 bg-gradient-to-b from-gray-900 via-black to-gray-900 overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-gradient-to-bl from-amber-500/10 to-transparent rounded-full blur-[150px]"></div>
        <div className="absolute bottom-0 left-0 w-[400px] h-[400px] bg-gradient-to-tr from-orange-500/10 to-transparent rounded-full blur-[100px]"></div>
        
        {/* Decorative Lines */}
        <div className="absolute top-20 left-10 w-32 h-32 border border-amber-500/10 rounded-full"></div>
        <div className="absolute bottom-20 right-10 w-48 h-48 border border-amber-500/10 rounded-full"></div>
        <div className="absolute top-1/2 right-1/4 w-24 h-24 border border-orange-500/10 rounded-full"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Photo Section First */}
        <div className="flex justify-center mb-12">
          <div className="relative group max-w-md">
            {/* Glow Effect */}
            <div className="absolute -inset-4 bg-gradient-to-r from-amber-500/30 to-orange-500/30 rounded-[2rem] blur-2xl opacity-50 group-hover:opacity-70 transition-opacity duration-500"></div>
            
            {/* Main Image Container */}
            <div className="relative rounded-3xl overflow-hidden border-4 border-amber-500/30 group-hover:border-amber-400/50 transition-colors duration-500">
              <img 
                src={coachImage} 
                alt="Rushneek Singh" 
                className="w-full h-auto object-cover transform group-hover:scale-105 transition-transform duration-700"
              />
              
              {/* Overlay Gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
            </div>

            {/* Badge */}
            <div className="absolute -bottom-5 left-1/2 -translate-x-1/2 z-20">
              <div className="relative group/badge">
                <div className="absolute -inset-1 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full blur opacity-70 group-hover/badge:opacity-100 transition-opacity"></div>
                <div className="relative bg-gradient-to-r from-amber-500 to-orange-500 text-black px-6 py-3 rounded-full font-bold shadow-xl whitespace-nowrap text-sm sm:text-base">
                  India's No.1 B2B Payment Recovery Coach
                </div>
              </div>
            </div>

            {/* Floating Stats Cards */}
            <div className="absolute -top-4 -right-4 bg-gradient-to-br from-green-500 to-emerald-600 text-white px-4 py-3 rounded-2xl shadow-xl animate-float">
              <p className="text-2xl font-black">₹43Cr+</p>
              <p className="text-xs opacity-80">Recovered</p>
            </div>
            
            <div className="absolute top-1/3 -left-4 bg-gradient-to-br from-amber-500 to-orange-500 text-black px-4 py-3 rounded-2xl shadow-xl animate-float-delayed">
              <p className="text-2xl font-black">25+</p>
              <p className="text-xs opacity-80">Years Exp</p>
            </div>
          </div>
        </div>

        {/* Header Section After Photo */}
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-amber-500/10 to-orange-500/10 border border-amber-500/20 text-amber-400 px-5 py-2 rounded-full text-sm font-medium mb-6">
            <span className="text-lg">👨‍🏫</span>
            Meet Your Coach
          </div>
          
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-black text-white">
            About Coach
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-amber-400 to-orange-500"> Rushneek Singh</span>
          </h2>
        </div>

        {/* Content Section */}
        <div className="max-w-4xl mx-auto">
          <div className="space-y-6">
            <div className="space-y-4 text-lg text-gray-300 leading-relaxed">
              <p>
                <span className="text-white font-bold text-xl">Rushneek Singh</span> is India's leading Payment Recovery Coach with over 
                <span className="text-amber-400 font-semibold"> 25 years of experience</span> in helping businesses recover their stuck payments.
              </p>
              
              <p>
                He has helped his mentees recover more than 
                <span className="text-green-400 font-bold text-2xl"> ₹43 Crores</span> from Indian markets in the past 60 months through his proven payment recovery system.
              </p>
              
              <p>
                Having conducted <span className="text-white font-semibold">104+ seminars and webinars</span>, he has guided over 
                <span className="text-white font-semibold"> 18,000+ business owners</span> to overcome their payment collection challenges.
              </p>

              <p>
                His <span className="text-amber-400 font-semibold">Payment Recovery Training Kit</span> is the result of decades of experience, distilled into actionable strategies that work in the real Indian market.
              </p>
            </div>


            {/* Trust Badges */}
            <div className="flex flex-wrap justify-center gap-3 pt-4">
              <div className="flex items-center gap-2 bg-gray-800/50 px-4 py-2 rounded-full border border-gray-700">
                <svg className="w-5 h-5 text-green-500" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
                <span className="text-gray-300 text-sm">Verified Expert</span>
              </div>
              <div className="flex items-center gap-2 bg-gray-800/50 px-4 py-2 rounded-full border border-gray-700">
                <span className="text-amber-400">★★★★★</span>
                <span className="text-gray-300 text-sm">4.7 Rating</span>
              </div>
            
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
        @keyframes float-delayed {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-8px); }
        }
        .animate-float { animation: float 4s ease-in-out infinite; }
        .animate-float-delayed { animation: float-delayed 5s ease-in-out infinite 1s; }
      `}</style>
    </section>
  );
}

export default AboutSection;
